import Table from "../../ui/Table/Table";
import { tableDate } from "../../utils/date.utils";
import { DeleteIcon, EditIcon } from "../../utils/icon.utils";
import { GroupBtn } from "../../ui/GroupBtn";
import { onConfirm } from "../../utils/sweetAlert.utils";
import { tableIndex } from "../../utils/table.utils";
import { currency } from "../../utils/number.utils";
import {
  getPaymentTypeById,
  useDeleteCustomerPaymentMutation
} from "../../utils/customerPayment.utils";
import Loading from "../../components/Loading";
import { arrayMap } from "../../utils/array.utils";

export default function PaymentList({ data, handleEdit: onEdit }) {
  // table head and body

  const thead = ["#", "Payment Date", "Payment Made", "Remarks", "Amount", "Date", "Action"];
  const tbody =
    arrayMap(data?.payments, (item, index) => {
      const date = item?.created_at ? tableDate(item.created_at) : "-";
      const paymentDate = item?.payment_date ? item.payment_date : "-";
      const paymentBy = item?.payment_type_id
        ? getPaymentTypeById(item.payment_type_id)?.label ?? "-"
        : "-";
      const amount = item?.amount ? currency(item.amount) : "-";
      return {
        "#": tableIndex(index),
        Date: date,
        "Payment Date": paymentDate,
        "Payment Made": paymentBy,
        Remarks: item?.remarks ?? "-",
        Amount: amount,
        ...item
      };
    }) || [];

  // delete mutation
  const { loading: deleting, deleteCustomerPayment } = useDeleteCustomerPaymentMutation([
    "deleteCustomerPayment"
  ]);

  // action component
  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      onEdit(item);
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();
      if (isConfirmed) {
        await deleteCustomerPayment(item?.id);
      }
    };

    const btns = [
      {
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      },
      {
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      }
    ];
    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = deleting;
  return (
    <>
      <Table thead={thead} tbody={tbody} action={ActionComponent} />

      <Loading loading={isLoading} />
    </>
  );
}
